import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useCallback, useReducer, useState } from "react";
import { createStore } from 'react-hooks-global-state'
import Button from "./control/Button";

const dialogReducer = (state, action) => {
    switch (action.type) {
        case "modal-dialog/show": {
            const { modalId, args, resolve } = action.payload;
            const { dialogs } = state;
            return {
                ...state,
                dialogs: { ...dialogs, [modalId]: { show: true, args: args, resolve: resolve } }
            }
        }
        case "modal-dialog/hide": {
            const { modalId } = action.payload;
            const { dialogs } = state;
            return {
                ...state,
                dialogs: { ...dialogs, [modalId]: { show: false } }
            }
        }
        default:
            return state;
    }
}

const showModal = (modalId, args, resolve) => {
    return {
        type: "modal-dialog/show",
        payload: {
            modalId,
            args,
            resolve
        }
    }
}

const hideModal = (modalId) => {
    return {
        type: "modal-dialog/hide",
        payload: {
            modalId
        }
    }
}

const { dispatch, useGlobalState } = createStore(dialogReducer, { dialogs: {} })

export const createModalDialog = (id) => {
    return (props) => {
        const modal = useModalDialog(id);
        if (modal.visible != true) return null;
        return <ModalDialog {...props} {...modal.args} resolve={modal.resolve} hide={modal.hide} />
    }
}

export const useModalDialog = (modalId) => {
    const [dialog] = useGlobalState('dialogs')

    const show = useCallback(
        (args) => {
            return new Promise((resolve) => {
                dispatch(showModal(modalId, args, resolve))
            })
        }, [dialog, modalId]
    )

    const hide = useCallback(
        () => {
            dispatch(hideModal(modalId))
        }, [dialog, modalId]
    )

    const args = dialog[modalId] == null ? {} : dialog[modalId].args;
    const visible = dialog[modalId] == null ? false : dialog[modalId].show;
    const resolve = dialog[modalId] == null ? null : dialog[modalId].resolve;

    return {
        args, visible, show, hide, resolve
    }

}

const ModalDialog = (props) => {
    const { title, context, hide, resolve, buttons = [{ id: "ok", name: "确定", type: "primary", action: "close" }] } = props;

    const closeModal = () => {
        if (hide != null) hide();
    }

    let btns = [];
    buttons.forEach(b => {
        btns.push(<Button className="mx-2" key={b.id} name={b.name} type={b.type} widthStyle={'w-full'} onClicked={e => {
            if (b.action == "close") {
                closeModal();
            }

            if (resolve != null) {
                resolve(b);
            }

        }} />)
    });

    return <div className=" relative z-10">
        <div className=" fixed inset-0 bg-black bg-opacity-25"></div>
        <div className=" fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
                <div className=" w-[80%] max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl ">
                    <div className="text-lg font-medium leading-6 text-gray-900">
                        {title}
                    </div>
                    <div className="w-full bg-gray-400 h-[1px] my-2"></div>
                    <div>
                        <div className="text-sm text-gray-500 break-words ">
                            {context}
                        </div>
                    </div>

                    <div className="mt-4 flex justify-between items-center">
                        {btns}
                    </div>
                </div>
            </div>
        </div>
    </div>

    // return <div>
    //     <Transition appear show={isOpen} as={Fragment}>
    //         <Dialog as="div" className="relative z-10" onClose={closeModal}>
    //             <Transition.Child
    //                 as={Fragment}
    //                 enter="ease-out duration-300"
    //                 enterFrom="opacity-0"
    //                 enterTo="opacity-100"
    //                 leave="ease-in duration-200"
    //                 leaveFrom="opacity-100"
    //                 leaveTo="opacity-0"

    //             >
    //                 <div className="fixed inset-0 bg-black bg-opacity-25" />
    //             </Transition.Child>

    //             <div className="fixed inset-0 overflow-y-auto">
    //                 <div className="flex min-h-full items-center justify-center p-4 text-center">
    //                     <Transition.Child
    //                         as={Fragment}
    //                         enter="ease-out duration-300"
    //                         enterFrom="opacity-0 scale-95"
    //                         enterTo="opacity-100 scale-100"
    //                         leave="ease-in duration-200"
    //                         leaveFrom="opacity-100 scale-100"
    //                         leaveTo="opacity-0 scale-95"
    //                     >
    //                         <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
    //                             <Dialog.Title
    //                                 as="h3"
    //                                 className="text-lg font-medium leading-6 text-gray-900"
    //                             >
    //                                 {title}
    //                             </Dialog.Title>
    //                             <div className="mt-2">
    //                                 <p className="text-sm text-gray-500">
    //                                     {context}
    //                                 </p>
    //                             </div>

    //                             <div className="mt-4">
    //                                 <button
    //                                     type="button"
    //                                     className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
    //                                     onClick={closeModal}
    //                                 >
    //                                     Got it, thanks!
    //                                 </button>
    //                             </div>
    //                         </Dialog.Panel>
    //                     </Transition.Child>
    //                 </div>
    //             </div>
    //         </Dialog>
    //     </Transition>
    // </div>
}